import { isConsumer } from 'owa-session-store';

const consumerPrivacyUrl = 'https://go.microsoft.com/fwlink/?LinkId=521839';
const enterprisePrivacyUrl = 'https://myaccount.microsoft.com/settingsandprivacy/privacy';

export default function getPrivacyUrl():
    | 'https://go.microsoft.com/fwlink/?LinkId=521839'
    | 'https://myaccount.microsoft.com/settingsandprivacy/privacy' {
    return isConsumer() ? consumerPrivacyUrl : enterprisePrivacyUrl;
}
